import { Badge } from '@startupquickstart/frontend';
import type { ComponentPropsWithoutRef } from "react";

type HotelStatus = 'published' | 'draft' | 'needs_review';

interface HotelStatusBadgeProps extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: HotelStatus;
}

function getStatusConfig(status: HotelStatus) {
  switch (status) {
    case 'published':
      return {
        variant: 'default' as const,
        label: 'Published',
      };
    case 'draft':
      return {
        variant: 'secondary' as const,
        label: 'Draft',
      };
    case 'needs_review':
      return {
        variant: 'destructive' as const,
        label: 'Needs Review',
      };
    default:
      return {
        variant: 'outline' as const,
        label: 'Unknown',
      };
  }
}

export function HotelStatusBadge({ status, className, ...props }: HotelStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
